module.exports = __webpack_public_path__ + "img/18f4cfbeabe5c822fd2dabd331b5e45a.d59e4f0e.webp";